import { Portal } from "@chakra-ui/react";
import React from "react";

type Props = {
  usePortal?: boolean;
  children?: React.ReactNode;
};

export const PortalWrapper = ({ usePortal, children }: Props) =>
  usePortal ? <Portal>{children}</Portal> : <>{children}</>;
